<template>
  <div class="mt-page">
    <slot />
  </div>
</template>
